import { cva } from 'class-variance-authority'

export const spinnerVariants = cva('animate-spin rounded-full border-solid', {
  variants: {
    variant: {
      black: 'border-primary',
      blue: 'border-blue-500',
      default: 'border-secondary',
      danger: 'border-white',
      white: 'border-white dark:border-black',
    },
    size: {
      sm: 'h-2.5 w-2.5',
      md: 'h-3 w-3',
      lg: 'h-3.5 w-3.5',
      xl: 'h-4 w-4',
      '2xl': 'h-8 w-8',
      '3xl': 'h-12 w-12',
    },
    thickness: {
      normal: 'border-2',
      thin: 'border-[1.5px]',
    },
  },
})
